import { CE_SCREEN_CLOSE } from "@js/actions/studio/screens.js";
import { getContent } from "@js/helpers/state.js";
import sha256 from "@js/helpers/sha256.js";
import { putJSON } from "@js/helpers/communication.js";

export const CE_VIEW_WEB_VERSION_OPEN = "CE_VIEW_WEB_VERSION_OPEN";
export const CE_VIEW_WEB_VERSION_ERROR = "CE_VIEW_WEB_VERSION_ERROR";
export const CE_VIEW_WEB_VERSION_READY = "CE_VIEW_WEB_VERSION_READY";
export const CE_VIEW_WEB_VERSION_ABORTED = "CE_VIEW_WEB_VERSION_ABORTED";
export const CE_VIEW_WEB_VERSION_TOGGLE_REPLACEMENT_CODES = "CE_VIEW_WEB_VERSION_TOGGLE_REPLACEMENT_CODES";

export const ceScreenViewWebVersionOpen = (clientContentID) => (dispatch, getState) => {
  dispatch({
    type: CE_VIEW_WEB_VERSION_OPEN,
    client_content_id: clientContentID,
  });

  let initialState = getState();
  let initialScreen = initialState.screen.uuid;

  let content = getContent(initialState, clientContentID);

  let contentID = content.id;
  let html = content.html;
  let htmlSha256 = sha256(content.html);
  let url = Routes.get_content_for_editor_preview_api_v2_campaign_update_path(contentID);

  // First try looking at the content by submitting the SHA256 of the version
  // we have. We do this to reduce bandwidth usage - and under normal circumstances,
  // it should work.
  putJSON(url, { sha256: htmlSha256 }, (response, err) => {
    let finalState = getState();
    let finalScreen = finalState.screen && finalState.screen.uuid;

    if ( !initialScreen || !finalScreen || initialScreen !== finalScreen ) {
      dispatch({
        type: CE_VIEW_WEB_VERSION_ABORTED,
        reason: "screen closed (1)",
      });
      return;
    }

    if ( err || !response.success ) {
      // Encountered an error; try by HTML.

      putJSON(url, { html: html }, (response, err) => {
        let finalState = getState();
        let finalScreen = finalState.screen && finalState.screen.uuid;

        if ( !initialScreen || !finalScreen || initialScreen !== finalScreen ) {
          dispatch({
            type: CE_VIEW_WEB_VERSION_ABORTED,
            reason: "screen closed (2)",
          });
          return;
        }

        if ( err || !response.success ) {
          // Error condition .. cannot show preview.
          dispatch({
            type: CE_VIEW_WEB_VERSION_ERROR,
          });
          return;
        }

        dispatch({
          type: CE_VIEW_WEB_VERSION_READY,
          plain_html: response.data.plain_html,
          replaced_html: response.data.replaced_html,
        });
      });
      return;
    }

    dispatch({
      type: CE_VIEW_WEB_VERSION_READY,
      plain_html: response.data.plain_html,
      replaced_html: response.data.replaced_html,
    });
    return;
  });
};

export const ceScreenViewWebVersionToggleReplacementCodes = () => ({
  type: CE_VIEW_WEB_VERSION_TOGGLE_REPLACEMENT_CODES,
});

export const ceScreenViewWebVersionCancel = () => ({
  type: CE_SCREEN_CLOSE,
});
